import React, { useState } from 'react';
import { toast } from 'sonner';

const td = { padding: 8 };

export const PaidLockedTable = ({ rows, onFix }) => {
  const [busy, setBusy] = useState(null);
  if (!rows || rows.length === 0) return null;

  const fix = async (email) => {
    if (!window.confirm(`Activate ${email} as Starter (fresh 20 emails) and notify the user?`)) return;
    setBusy(email);
    try {
      await onFix(email);
      toast.success(`${email} activated`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Fix failed');
    }
    setBusy(null);
  };

  return (
    <div style={{ marginTop: 20 }} data-testid="paid-locked-section">
      <h4 style={{ color: '#f1f4f9', fontSize: 14, marginBottom: 8 }}>Paid-but-still-locked mailboxes</h4>
      <div className="table-wrap" style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', color: '#e6e9ef', fontSize: 13 }} data-testid="paid-locked-table">
          <thead>
            <tr style={{ textAlign: 'left', borderBottom: '1px solid #2a3142', color: '#f1f4f9' }}>
              <th style={td}>Mailbox</th><th style={td}>User</th><th style={td}>Plan now</th>
              <th style={td}>Emails</th><th style={td}>Paid transactions (this chat)</th><th style={td}></th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const key = r.email_address.split('@')[0];
              return (
                <tr key={r.email_address} style={{ borderBottom: '1px solid #1e2430' }} data-testid={`paid-locked-row-${key}`}>
                  <td style={td}>{r.email_address}</td>
                  <td style={td}>{r.name || '—'} <span style={{ color: '#7d8799' }}>({r.chat_id})</span></td>
                  <td style={{ ...td, color: '#f59e0b' }}>{r.plan_type || 'none'}</td>
                  <td style={td}>{r.emails_received}</td>
                  <td style={{ ...td, color: '#b6bfce' }}>{r.payments.join(' · ') || '—'}</td>
                  <td style={td}>
                    <button
                      onClick={() => fix(r.email_address)}
                      disabled={busy === r.email_address}
                      data-testid={`paid-locked-fix-${key}`}
                      style={{ background: '#22c55e', color: '#0b1210', border: 0, borderRadius: 6, padding: '6px 12px', fontWeight: 700, cursor: 'pointer' }}
                    >
                      {busy === r.email_address ? 'Fixing…' : 'Fix'}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p style={{ color: '#7d8799', fontSize: 12, marginTop: 6 }}>
        Fix sets the mailbox to Starter with 20 fresh emails and sends the user a Telegram confirmation. Check the payments first: a chat may have paid for a different address.
      </p>
    </div>
  );
};

export default PaidLockedTable;
